<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <CustomerInfo></CustomerInfo>
      <CustomerTransactions></CustomerTransactions>
    </div>
  </div>
</template>

<script>
import CustomerInfo from "../CustomerInfo";
import CustomerTransactions from "../CustomerTransactions";
export default {
  name: "CustomerDetail",
  components: {CustomerTransactions, CustomerInfo},
}
</script>

<style scoped>
.info th {
  text-align: right;
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CustomerDetail.vue